import { MediaFile } from './media-file.types';

const MIME_BY_EXTENSION = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',

  mp4: 'video/mp4',
  webm: 'video/webm',

  pdf: 'application/pdf',
} as const;

type KnownExtension = keyof typeof MIME_BY_EXTENSION;

export const getFileExtension = (name: string): string | undefined => {
  return name.split('.').pop()?.toLowerCase();
};

export const getMimeTypeByFileName = (name: string): string => {
  const ext = getFileExtension(name);
  const fallbackMimeType = 'application/octet-stream';

  if (!ext) {
    return fallbackMimeType;
  }

  return MIME_BY_EXTENSION[ext as KnownExtension] ?? fallbackMimeType;
};

export const getMediaFileType = (mimeType: string): MediaFile['type'] => {
  if (mimeType.startsWith('image/')) {
    return 'image';
  }

  if (mimeType.startsWith('video/')) {
    return 'video';
  }

  return 'other';
};
